export function getSanityStudioUrl(dataset?: string) {
  if (process.env.NEXT_PUBLIC_SANITY_STUDIO_URL) {
    return process.env.NEXT_PUBLIC_SANITY_STUDIO_URL;
  }

  if (process.env.VERCEL_ENV === 'production' || dataset === 'production') {
    return '/sanity';
  }

  return dataset ? `/sanity/${dataset}` : '/sanity';
}
